import useSWR from 'swr'

import {
  GetRetrainHistoryResponse,
  GetRetrainHistoryVars,
  RetrainApiPath
} from '@/common/api/params/retrain'

export const useRetrainHistoryGetApi = (
  vars: GetRetrainHistoryVars,
  options?: { refreshInterval?: number }
) => {
  return useSWR<GetRetrainHistoryResponse, Response, [string, GetRetrainHistoryVars]>(
    [RetrainApiPath.GET_RETRAIN_HISTORY, vars],
    options
  )
}
